import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import MobileMenu from '../MobileMenu/MobileMenu'



const ClickHandler = () => {
  window.scrollTo(10, 0)
}
const Header = (props) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset;
      if (scrollTop > 100) { 
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header id="header">
      <div className={`${props.hclass || ''} ${isScrolled ? 'scrolled' : ''}`.trim()}>
        <nav className="navigation navbar navbar-expand-lg navbar-light">
          <div className="container-fluid">
            <div className="row align-items-center g-0">
              <div className={'' + props.col2}>
                <div className="navbar-header">
                  <Link
                    onClick={ClickHandler}
                    className="navbar-brand"
                    to="/home"
                  >
                    <img src={props.Logo} alt="" />
                  </Link>
                </div>
              </div>
              <div className={'' + props.col1}>
                <div className="mobail-menu">
                  <MobileMenu />
                </div>
              </div>
              <div className={'' + props.col3}>
                <div
                  id="navbar"
                  className="collapse navbar-collapse navigation-holder"
                >
                  <button className="menu-close">
                    <i className="ti-close"></i>
                  </button>
                  <ul className="nav navbar-nav mb-2 mb-lg-0">
                    <li className="menu-item-has-children image-style-item">
                      <Link onClick={ClickHandler} to="/home">
                        Home
                      </Link>
                     
                    </li>
                    {/* <li className="menu-item-has-children">
                      <Link onClick={ClickHandler} to="/services">
                        Services
                      </Link>
                      
                    </li> */}
                    <li className="menu-item-has-children">
                      <Link onClick={ClickHandler} to="/projects">
                        Products
                      </Link>
                     
                    </li>
                    <li className="menu-item-has-children">
                      <Link onClick={ClickHandler} to="/contact">
                        Contact Us
                      </Link>
                     
                    </li>
                   
                  </ul>
                </div>
              </div>
              {/* <div className={'' + props.col4}>
                <div className="header-right">
                
                  <div className="close-form">
                    <Link
                      className="theme-btn"
                      onClick={ClickHandler}
                      to="/contact"
                    >
                      Contact Now
                    </Link>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </nav>
      </div>
    </header>
  )
}

export default Header
